import React, { useState, useEffect } from "react";
import Translator from "../services/Translator";
import coatOfArms from "../assets/images/coat_of_arms.png";
import PinDots from "./security/PinDots";
import {config} from "../config";
import axios from "axios";

const PIN_KEY = "pin";
let LIMIT = 3;

let unlocked = false;
const listeners = new Set();

export function unlockApp() {
    unlocked = true;
    listeners.forEach((fn) => fn());
}

export function lockApp() {
    unlocked = false;
    listeners.forEach((fn) => fn());
}

export function isAppUnlocked() {
    if (localStorage.getItem(PIN_KEY) === null) return true;

    return unlocked;
}


export function useAppUnlocked() {
    const [isUnlocked, setIsUnlocked] = useState(() => isAppUnlocked());

    useEffect(() => {
        const listener = () => setIsUnlocked(isAppUnlocked());
        listeners.add(listener);
        return () => listeners.delete(listener);
    }, []);

    return isUnlocked;
}

export default function PinGate({lang, setPreloaderState, setToken, refreshUser}) {
    const [value, setValue] = useState("");
    const [error, setError] = useState(false);
    const [superError, setSuperError] = useState(false);

    const press = (digit) => {
        setError(false);
        if (value.length >= config.pinLength) return;
        const next = value + digit;
        setValue(next);
        if (next.length === config.pinLength) {
            setTimeout(() => {
                if (next === localStorage.getItem(PIN_KEY)) {
                    unlockApp();
                    setValue("");
                    setError(false);
                } else {
                    setValue("");
                    setError(true);
                    if (--LIMIT === 0) {
                        setSuperError(true);

                        const token = localStorage.getItem('token');
                        localStorage.removeItem(PIN_KEY);
                        localStorage.removeItem('token');

                        axios.post(
                            config.api + '/cancel-token',
                            {
                                token: token
                            })
                            .then((response) => {
                                setToken(null);
                            }).catch((response) => {
                                setPreloaderState(false);
                            });
                    }
                }
            }, 150);
        }
    };

    const backspace = () => {
        setError(false);
        setValue(value.slice(0, -1));
    };

    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 4000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
            onPaste={(e) => e.preventDefault()}
        >
            <div>
                <div style={{textAlign: 'center', marginBottom: '20px'}}>
                    <img src={coatOfArms} alt={Translator.trans(lang, 'registration.coat_of_arms')} style={{height: '75px', marginBottom: '35px'}} />
                    <h1>{Translator.trans(lang, 'security.pin.title')}</h1>
                </div>

                {/*<input*/}
                {/*    type="text"*/}
                {/*    inputMode="none"*/}
                {/*    readOnly*/}
                {/*    value={'●'.repeat(value.length)}*/}
                {/*    className="form-control text-center fs-4 mb-3"*/}
                {/*    style={{letterSpacing: '0.5em'}}*/}
                {/*    onFocus={(e) => e.target.blur()}*/}
                {/*    onKeyDown={(e) => e.preventDefault()}*/}
                {/*/>*/}
                <div style={{width: '300px'}}>
                    <PinDots filled={value.length} total={config.pinLength} />
                </div>

                {error && !superError && (
                    <div className="alert alert-danger py-2" style={{width: '300px'}}>
                        {Translator.trans(lang, 'security.pin.error')}
                    </div>
                )}

                {superError && (
                    <div className="alert alert-danger py-2" style={{width: '300px'}}>
                        {Translator.trans(lang, 'security.pin.blocked')}
                    </div>
                )}

                <div className="d-grid gap-2">
                    {[0, 1, 2].map((row, index) => (
                        <div className="row g-2" key={row}>
                            {[1 + (3 * row), 2 + (3 * row), 3 + (3 * row)].map((digit) => (
                                <div className="col-4" key={digit}>
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary w-100 fs-4"
                                        onClick={() => press(String(digit))}
                                    >
                                       {digit}
                                    </button>
                                </div>
                            ))}
                        </div>
                    ))}

                    <div className="row g-2">
                        <div className="col-4" />
                        <div className="col-4">
                            <button
                                type="button"
                                className="btn btn-outline-primary w-100 fs-4"
                                onClick={() => press('0')}
                            >
                                0
                            </button>
                        </div>
                        <div className="col-4">
                            <button
                                type="button"
                                className="btn btn-outline-danger w-100 fs-4"
                                onClick={backspace}
                                disabled={value.length === 0}
                            >
                                ⌫
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}